import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {combineReducers} from "redux"; 
import cardSlice from './features/cardSlice';
import authSlice from './features/authSlice';
import sessionSlice from './features/sessionSlice';
import vendorSlice from './features/vendor/vendorSlice';
import branchSlice from './features/branch/branchSlice';
import companySlice from './features/companySlice';
import uiReducer from "./features/uiSlice";

const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = combineReducers({
  cardState: cardSlice,
  authState : authSlice,
  companyState :  companySlice,
  sessionState :  sessionSlice,
  
    vendorState : vendorSlice,
    branchState : branchSlice,
      ui: uiReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { store, persistor };


// export default configureStore({
//   reducer: {
//     counter: counterReducer,
//     editService : editServiceSlice,
//     newservice : serviceSlice

//   }
// })
